import React from 'react';
import Loader from "react-loader-spinner";
import { MdClose } from 'react-icons/md';

const PreviewImgModal = ({loading, data, showModal, handleCancel}) => {
    let imgSrc = `data:${data.contentType};base64,` + data.content;
    return(
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content bg-transparent" style={{boxShadow: 'none'}}>
                        <div className="modal-header border-transparent d-flex justify-content-end">
                            <button type="button" className="close rounded-xl bg-white text-dark p-2" aria-label="Close" onClick={handleCancel}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body d-flex justify-content-center">
                            {loading ? <Loader type="ThreeDots" color="#fff" height={40} width={40} /> 
                                : <img src={imgSrc} alt="Preview" style={{ width: '50%', height: '50%' }} />}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show" style={{opacity: 0.6}}></div>
        </div>
    );
};

export default PreviewImgModal;